module.exports = __webpack_public_path__ + "img/uy.2d8cc05d.svg";